module.exports = __webpack_public_path__ + "img/14-oneImg.8f5ba31e.png";